module.exports = __webpack_public_path__ + "img/1592026307.f714fbc7.jpg";